export class LogConfigurationModel {
  public logRetentionSnap: number;
  public logRetentionSoftware: number;
  public logRetentionInk: number;

  constructor() {
    this.logRetentionSnap = 31;
    this.logRetentionSoftware = 31;
    this.logRetentionInk = 31;
  }
}